import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetValidateDocumentAuditHistory } from './hooks';

export default function ValidateDocumentAuditHistory() {
  const { customerRecordId, employerId, documentId } = useParams();

  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetValidateDocumentAuditHistory(
    customerRecordId,
    employerId,
    documentId,
  );

  return (
    <Layout
      pageEnum={'INCOME'}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
